import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { useToast } from "@/context/ToastContext";
import { useAuth } from "@/context/AuthContext";
import { Loader, Currency, Field } from "@/components/Atoms";
import {
  Shield, Users, Crown, Coins, Settings, Wrench, Ban, ScrollText, Map as MapIcon,
  UserCog, Layers, Gift, PackageOpen, Server, Lock, KeyRound, Flame, Calendar,
  Flag, Sparkles, RefreshCw, Timer
} from "lucide-react";



export function PalGameSettings() {
  const [text, setText] = useState("{}");
  const [loading, setLoading] = useState(true);
  const toast = useToast();
  useEffect(() => {
    api.get("/admin/palgame/settings").then(({ data }) => setText(JSON.stringify(data.settings || {}, null, 2))).finally(() => setLoading(false));
  }, []);
  const save = async () => {
    try {
      const parsed = JSON.parse(text);
      await api.put("/admin/palgame/settings", parsed);
      toast.success("Saved");
    } catch (e) { toast.error(e?.message || apiError(e)); }
  };
  if (loading) return <Loader />;
  return (
    <div className="space-y-3 fade-up">
      <div
        className="glass-card p-3 text-xs text-[var(--muted)] flex items-start gap-2"
        data-testid="palgame-cooldowns-notice"
      >
        <Timer size={14} className="text-[var(--teal)] shrink-0 mt-0.5" />
        <span>
          Cooldown fields (<code>catch_cooldown</code>, <code>battle_cooldown</code>,
          {" "}<code>adventure_cooldown</code>) are managed in{" "}
          <Link to="/admin/cooldowns" className="underline hover:text-[var(--bone)]">
            Admin → Cooldowns
          </Link>
          . If you add them here they'll be ignored on save.
        </span>
      </div>
      <p className="text-sm text-[var(--muted)]">JSON config for rewards, fusion costs, and other pal-game tuning.</p>
      <textarea className="input font-mono text-xs" rows={20} value={text} onChange={(e) => setText(e.target.value)} data-testid="palgame-config-textarea" />
      <button onClick={save} className="btn" data-testid="palgame-config-save">Save</button>
    </div>
  );
}
